export const oauthPaths = ['/trial', '/register', '/signup/xero']